import Vue from 'vue';
import { DataService } from '../../data.service';

const chartID = 'getCountyWetlandFreshwaterAreaChange';
const mainChartTitle = 'Freshwater Palustrine Wetlands'
/**
 * Tab 4: Wetlands: Percent Net Decrease Of Freshwater Palustrine Wetlands
 * getCountyWetlandFreshwaterAreaChange
 */
export class Tab4Chart3 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    calculateTitle = function () {
        let changeText;
        if (this.chart.value < 0) changeText = 'Percent Net Decrease of';
        else if (this.chart.value > 0) changeText = 'Percent Net Increase of';
        else changeText = "No Change in"
        return changeText + ' ' + mainChartTitle;
    };

    updateChartData(response) {
        this.chart.value = +response.value;
        this.chart.infographic.title = this.calculateTitle();
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        loading: true
                    },
                    value: 0.0
                }
            },
            computed: {
                direction: function () {
                    if (this.value < 0) return 'down';
                    else if (this.value > 0) return 'up';
                    else return 'hide';
                },
                color: () => {
                    return {
                        color: "#336699" //blue
                    };
                }
            }
        });
        //end vue component
    }
}
